export default __webpack_public_path__ + "static/N0008-b7df3feb5645d1df486f05eb798859d2.png";